import {observer} from "mobx-react";
import PageAncestor from "../../../core/common/page/pageAncestor";
import {MODULE, PageProps} from "../../../core/metamodel/metaConstant";
import {loc} from "../../../core/common/config/locales";
import {LIFESPAN_LIST} from "../../gridsContants";
import gridService from "../../../core/grid/gridService";
import GridCompConnected from "../../../core/grid/component/gridCompConnected";
import mdEntityService from "../../../core/metamodel/mdEntityService";
import React from "react";


@observer
export default class LifespanList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.sbtool;
  static title = loc.i18n`Lifespan`;
  static icon = 'list';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("LifespanList#fetchData(%s)", LIFESPAN_LIST);

    return gridService.fetchGrids(LIFESPAN_LIST)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(LIFESPAN_LIST);
      });
  }

  render() {
    let { params, query } = this.props;


    return (
      <GridCompConnected grid={gridService.getOrCreateGrid(LIFESPAN_LIST)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query} />
    );
  }


}



// WEBPACK FOOTER //
// ./src/sbtool/page/material/lifespanList.tsx